import React, {useState} from 'react';
import putWithAuth from "../../context/putWithAuth";

function SeatingChart({ groups, school, groupModal, setSeatingChart, setGroupModal}) {

    const [isLoading, setIsLoading] = useState(false);
    const [permGroups, setPermGroups] = useState(groups);
    const [updatedGroups, setUpdatedGroups] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const colors = ['#e48a66', '#538ea5', '#ece0c0', '#1c2f37']
    const textColors = ['#1c2f37', '#ece0c0', '#1c2f37', '#ece0c0']

    function handleStudentClick(e) {
        if (selectedStudent) {
            let firstStudentCoords = [...selectedStudent]
            let firstStudentInfo = groups[firstStudentCoords[0]][firstStudentCoords[1]]
            let secondStudentCoords = e.target.id.split('-').map(value => parseInt(value, 10))
            let secondStudentInfo = groups[secondStudentCoords[0]][secondStudentCoords[1]]
            let tempGroups = [...groups]
            tempGroups[firstStudentCoords[0]][firstStudentCoords[1]] = secondStudentInfo
            tempGroups[secondStudentCoords[0]][secondStudentCoords[1]] = firstStudentInfo
            setPermGroups(tempGroups);
            setSelectedStudent(null)
        } else {
            const coord = e.target.id.split('-').map(value => parseInt(value, 10));
            setSelectedStudent(coord)
        }
    }

    const putSaveSeatingChart = () => {
        let seatingChart = {
            groups: groups,
            rosterId: groupModal.roster._id.$oid
        };
        setIsLoading(true);
        putWithAuth('/logistics/putSaveSeatingChart', school, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: seatingChart
        })
            .then(async response => {
                if (response.ok) {
                    setSeatingChart(permGroups);
                    setUpdatedGroups(permGroups)
                    setIsLoading(false)
                    setGroupModal(prev => {
                        prev.chartType = 'Seating Chart';
                        return prev;
                    })
                } else {
                    console.error('Failed to save Seating Chart');
                    setIsLoading(false)
                }
            })
            .catch(error => {
                console.error('Error publishing seating chart:', error);
                setIsLoading(false)
            });
    };

    return (
        <>
            <div
                className={"bg-columbia_blue-900 p-2 text-black cursor-black rounded-b rounded-tr overflow-y-auto shadow-xl"}>
                <div className={"bg-dutch_white-300 text-lg text-columbia_blue-900 p-2 rounded shadow flex"}>
                    <div className={'grow'}/>
                    <div>
                        <p className={'font-bold'}>{groupModal.roster.title}</p>
                        <p className={'text-xs'}>{groupModal.roster.prep}</p>
                    </div>
                    <div className={'grow'}/>
                </div>

                <div className={"grid grid-cols-4 my-2 gap-2"}>
                    {permGroups && permGroups.map((group, groupIndex) =>
                        <div className={"h-full flex flex-col bg-platinum-300 rounded p-1"}>
                            <p className={'font-bold'}>Group {groupIndex + 1}</p>
                            {group.map((student, index) =>
                                (selectedStudent && selectedStudent[0] === groupIndex && selectedStudent[1] === index) ?
                                    <button
                                        onClick={handleStudentClick}
                                        id={`${groupIndex}-${index}`}
                                        className={'text-center p-1 hover:opacity-[85%] animate-pulse rounded mb-1 bg-burnt_sienna text-dutch_white-700 shadow grow flex flex-col cursor-pointer'}
                                        style={{background: colors[index % 4], color: textColors[index % 4]}}>
                                        <div id={`${groupIndex}-${index}`} className={'grow'}/>
                                        <p id={`${groupIndex}-${index}`}
                                           className={'mx-auto'}>{student.firstName} {student.lastName}</p>
                                        <div id={`${groupIndex}-${index}`} className={'grow'}/>

                                    </button>
                                    :
                                    <button
                                        onClick={handleStudentClick}
                                        id={`${groupIndex}-${index}`}
                                        className={'text-center p-1 hover:opacity-[85%] rounded mb-1 bg-burnt_sienna text-dutch_white-700 shadow grow flex flex-col cursor-pointer'}
                                        style={{background: colors[index % 4], color: textColors[index % 4]}}>
                                        <div id={`${groupIndex}-${index}`} className={'grow'}/>
                                        <p id={`${groupIndex}-${index}`}
                                           className={'mx-auto'}>{student.firstName} {student.lastName}</p>
                                        <div id={`${groupIndex}-${index}`} className={'grow'}/>

                                    </button>)}
                        </div>
                    )}
                </div>
                {(!isLoading) ? (permGroups !== groups) &&
                    <button onClick={putSaveSeatingChart}
                            className="absolute self-center rounded -bottom-5 left-[50%] -translate-x-1/2 align-middle p-2 bg-columbia_blue-700 text-dutch_white-200 font-bold px-10 hover:bg-columbia_blue-600">
                        <p>Save Seating Chart</p>
                    </button> :
                    <button className="absolute self-center rounded -bottom-5 left-[50%] -translate-x-1/2 align-middle p-2 bg-columbia_blue-700 text-dutch_white-200 font-bold px-10 hover:bg-columbia_blue-600">
                        <div className="border-t-2 border-b-2 border-burnt_sienna h-6 w-6 rounded-full animate-spin mx-auto"></div>
                    </button>
                }
            </div>
        </>
    );
}

export default SeatingChart;